import React from 'react';
import { Button } from 'reactstrap';

export const PrintBill = ({ currentOrder, totalAmount, customerName, totalDiscount }) => {
  const handlePrintBill = () => {
    const printContents = document.getElementById('bill-content').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  return (
    <Button color="secondary" onClick={handlePrintBill}>
      Print Bill
    </Button>
  );
};